import api, { globalErrorHandler } from "../Api";

export const DELETE_PERSONAL_DAYS = "DELETE_PERSONAL_DAYS";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_PERSONALDAYS = "GET_PERSONALDAYS";
export const GET_TIMEINTERVALS = "GET_TIMEINTERVALS";
export const INITIAL_USER_VALIDATION = "INITIAL_USER_VALIDATION";
export const PD_ERROR = "PD_ERROR";
export const PD_LOADING = "PD_LOADING";
export const PD_LOADING_ACTION = "PD_LOADING_ACTION";
export const PD_LOADINGCATEGORIES = "PD_LOADINGCATEGORIES";
export const PD_LOADING_VALIDATION = "PD_LOADING_VALIDATION";
export const POST_PERSONALDAYS = "POST_PERSONALDAYS";
export const UPDATE_REQUEST_DATE = "UPDATE_REQUEST_DATE";

export const GetPersonalDays = () => {
    const config = {
        headers: {
            'content-type': 'application/json',
        }
      }  
    return async dispatch => {
      dispatch({
        type: PD_LOADING
      });
      await api.get(`/PersonalDays/GetDaysRequests`,config).then(res => {
        dispatch({
          type: GET_PERSONALDAYS,
          data: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: PD_ERROR,
        })
      });
    };
  };

  export const InitialUserValidation = (badge) => {
    const config = {
        headers: {
            'content-type': 'application/json',
        }
      }  
    return async dispatch => {
      dispatch({
        type: PD_LOADING_VALIDATION
      });
      await api.get(`/PersonalDays/InitialUserValidation/${badge}`,config).then(res => {
        dispatch({
          type: INITIAL_USER_VALIDATION,
          data: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: PD_ERROR,
        })
      });
    };
  };

  export const GetCategories = () => {
    const config = {
        headers: {
            'content-type': 'application/json',
        }
      }  
    return async dispatch => {
      dispatch({
        type: PD_LOADINGCATEGORIES
      });
      await api.get(`/PersonalDays/GetCategories`,config).then(res => {
        dispatch({
          type: GET_CATEGORIES,
          data: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: PD_ERROR, 
        })
      });
    };
  };

  export const AddPersonalDays = (payload) => {
      const config = {
          headers: {
              'content-type': 'application/json',
          }
      }
    return async dispatch => {
        dispatch({
            type: PD_LOADING
        });
  
        api.post(`/PersonalDays/AddRequestDay`, 
        payload, config).then(res => {
            dispatch({
                type: POST_PERSONALDAYS,
                payload: res.data,
                data: res.data
            });
        })
        .catch((error) => {
          globalErrorHandler(error);
          dispatch({
            type: PD_ERROR,
          })
        });
    };
  };
  
  export const UpdateRequestDate = (payload) => {
      const config = {
          headers: {
              'content-type': 'application/json',
          }
      }
    return async dispatch => {
        dispatch({
            type: PD_LOADING_ACTION
        });
  
        await api.post(`/PersonalDays/UpdateReqestDate/${payload.id}?requestDate=${payload.requestDate}&comment=${payload.comment}`, 
        payload, config).then(res => {
            dispatch({
                type: UPDATE_REQUEST_DATE,
                payload: res.data,
                data: res.data
            });
        })
        .catch((error) => {
          globalErrorHandler(error);
          dispatch({
            type: PD_ERROR,
          })
        });
    };
  };

export const GetTimeIntervalsByCategory = (id) => {
  const config = {
      headers: {
          'content-type': 'application/json',
      }
  }
  return async dispatch => {
      if (id === undefined || id === null || id === "") {
          return;
      }
      dispatch({
          type: PD_LOADING
      });

      api.get(`/PersonalDays/GetTimeIntervalsByCategory/${id}`, 
      config).then(res => {
          dispatch({
              type: GET_TIMEINTERVALS,
              payload: res.data,
              data: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: PD_ERROR,
        })
      });
  };
};

export const DeletePersonalDays = (id) => {
  const config = {
      headers: {
          'content-type': 'application/json',
      }
  }
  return async dispatch => {
      dispatch({
          type: PD_LOADING_ACTION
      });

      await api.delete(`/PersonalDays/Delete/${id}`, 
      config).then(res => {
          dispatch({
              type: DELETE_PERSONAL_DAYS,
              payload: res.data,
              data: res.data
          });
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: PD_ERROR,
        })
      });
  };
};